import { createFileRoute, useParams } from '@tanstack/react-router';
import { HStack, Spacer, VStack } from '@/components/Layout';
import { Loader } from '@/components/Loading';
import { Text } from '@/components/Typography/Text';
import { HistoryItem, TableofContentsLeftRail } from '@/features/history';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { useGetValueActivities } from './-query';
export const Route = createFileRoute('/_stacktrace/values/$id/_layout/history/')({
  component: ValueHistoryTab
});

/**
 * Value 詳細 > 履歴タブ。
 *
 * BE `/v2/product-central/values/{id}/activities` を limit=100 で叩き、共有
 * `features/history` 配下の `HistoryItem` / `TableofContentsLeftRail` で
 * Issue 詳細と同じ UI を再利用する。
 */
function ValueHistoryTab() {
  const {
    id
  } = useParams({
    from: '/_stacktrace/values/$id/_layout/history/'
  });
  const {
    data,
    isPending
  } = useGetValueActivities(id);
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'values.detail.history'
  });
  if (isPending || !data) {
    return <Loader />;
  }
  if (data.histories.length === 0) {
    return <VStack className="flex-1 items-center justify-center py-12">
        <Text variant="labelSemiLarge" className="text-neutral-muted-on-fill">
          {t('empty')}
        </Text>
      </VStack>;
  }
  return <HStack className="h-full p-10 gap-8">
      <nav className="sticky top-0 h-fit w-[240px]">
        <TableofContentsLeftRail historiesGroupByValidFrom={data.historiesGroupByValidFrom} basePath={`/values/${id}/history`} />
      </nav>
      <VStack className="w-full relative">
        <Spacer size={24} />
        <HistoryItem historiesGroupByValidFrom={data.historiesGroupByValidFrom} />
      </VStack>
    </HStack>;
}